import { SurveyQuestionQm } from '~lib/generatedGqlTypes';

const filterVisibleQuestions = (
  questionsToFilter: SurveyQuestionQm[],
  visibleQuestionIds?: string[]
): SurveyQuestionQm[] => {
  if (visibleQuestionIds === undefined) {
    return questionsToFilter;
  }

  return questionsToFilter.filter(question => visibleQuestionIds.includes(question.id));
};

export default filterVisibleQuestions;
